import axios from 'axios'
import Qs from 'qs'
import store from '@/store/index'
import router from '@/router/index'
// import fundebug from 'fundebug-javascript'
import $message from './message'
import $util from '@/utils/utils'
import $i18 from '@/utils/I18.js'
const fetch = axios.create({
  baseURL: process.env.VUE_APP_API_CUSTOMER_API
  // "Access-Control-Allow-Origin": "*" // 前端配置跨域请求头，一般配置代理
})

fetch.interceptors.request.use( // 请求拦截器
  config => {
    // removePending(config)
    // config.cancelToken = new CancelToken(c => {
    //   pending.push({
    //     u: config.url + '&' + config.method,
    //     f: c
    //   })
    // })
    if (localStorage.getItem("accessToken")) {
      config.headers.Authorization = localStorage.getItem("accessToken")
      config.headers.language = localStorage.getItem("language") || 'zh'
      config.headers.website = $util.getCurrentWebSite();
      config.headers.unionKey = 'gt6';
      // brToken单独处理
      if(config.url.indexOf("/user/getTokenByBrToken")<0) {
        if (config.data) {
          config.data.token = localStorage.getItem("accessToken")
        } else {
          config.data = {
            token: localStorage.getItem("accessToken")
          }
        }
      }
    }
    if (config.url.indexOf('api/centralconsole') < 0) {
      // config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
      // config.transformRequest = [function (data) {
      //   return Qs.stringify(data)
      // }]
    }
    return config
  },
  error => {
    // fundebug.notify(error)
    return Promise.reject(error)
  }
)

fetch.interceptors.response.use(
  response => {
    const res = response.data
    res.code = Number(res.code)
    if (res.code !== 200) {
      // 401: 登录过期或token失效  403: 权限不足  500: 系统内部错误
      $message({
        message: res.msg,
        type: 'warning',
        duration: 5 * 1000
      })
      switch (res.code) {
        case 401:
          if (localStorage.getItem('yisou3_token')) {
            $util.loginOutUrl(router.history.current.fullPath);
          }
          break
        case 500:
          // fundebug.notify(res)
          $message({
            message: $i18.language('当前您的网络环境不稳定，请检查您的网络环境或重新刷新此页面。'),
            type: 'warning',
            duration: 5 * 1000
          })
          break
        default:
          if (res.code !=201) {
            $message({
              message: res.msg ? res.msg : res.code + '-' + $i18.language('系统繁忙'),
              type: 'warning',
              duration: 5 * 1000
            })
          }
          break
      }
      return Promise.reject(res)
    } else {
      return response.data
    }
  },
  error => {
    if (error.response.status === 401) {
      window.localStorage.removeItem('pro_list')
      window.localStorage.removeItem('yisou3_token')
      $message({
        message: $i18.language('登录超时,请重新登录！'),
        type: 'warning',
        duration: 5 * 1000
      })
      $util.loginOutUrl(router.history.current.fullPath);
    } else {
      // fundebug.notify(error)
      $message({
        message: $i18.language('当前您的网络环境不稳定，请检查您的网络环境或重新刷新此页面。'),
        type: 'warning',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
  }
)

export default fetch
